/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Home icon.
 */
export const ICON_CAPABILITY_HOME = (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M8 22C4.68629 22 2 19.3137 2 16V8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8ZM10.4765 13.3167V17.2194C10.4765 17.6487 10.1341 18 9.71567 18H7.43308C7.01461 18 6.67222 17.6487 6.67222 17.2194V11.7556H5.37875C5.02876 11.7556 4.86897 11.3107 5.12767 11.0765L11.4885 5.19903C11.7776 4.93364 12.2189 4.93364 12.508 5.19903L18.8689 11.0765C19.1352 11.3107 18.9678 11.7556 18.6178 11.7556H17.3243V17.2194C17.3243 17.6487 16.9819 18 16.5634 18H14.2809C13.8624 18 13.52 17.6487 13.52 17.2194V13.3167H10.4765Z"
      fill="#26324B"
      fillRule="evenodd"
    />
  </svg>
);
